export default "__VITE_ASSET__C6po_5Qn__"